import FeatureContainer from './feature_container';

const Feature = FeatureContainer;
export default Feature;
